// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'EB Garamond', 'EB Garamond Fallback'","fontStyle":"normal"},"className":"__className_9b4f42","variable":"__variable_9b4f42"};